// in dev, this makes Vite inject its client as this module's first dependency,
// so that global constant replacements are installed before any other module
// (including user hooks) evaluates. In build it's inert.
import.meta.hot;




export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83')
];

export const server_loads = [];

export const dictionary = {
		"/": [8],
		"/(auth)/admin/integrations": [9,[2]],
		"/(auth)/admin/poster-builder": [10,[2]],
		"/(auth)/admin/settings": [11,[2]],
		"/(auth)/admin/theme": [12,[2]],
		"/(auth)/admin/users": [13,[2]],
		"/check-email": [72],
		"/dashboardnew": [73],
		"/(auth)/dashboard": [14,[2]],
		"/(auth)/dashboard/explore-next": [16,[2]],
		"/(auth)/dashboard/explore": [15,[2]],
		"/(auth)/dashboard/innstillinger": [17,[2]],
		"/(auth)/dashboard/screens": [18,[2]],
		"/(auth)/dashboard/screens/[id]/play": [19,[2]],
		"/link-service": [74],
		"/link-service/[id]": [75],
		"/login": [76],
		"/plakat": [77,[6]],
		"/plakat/innstillinger": [78,[6]],
		"/plakat/[id]": [79,[6]],
		"/(auth)/plakat/[id]/rediger": [20,[2]],
		"/(auth)/priser": [21,[2]],
		"/(auth)/priser/innstillinger": [22,[2]],
		"/(auth)/product/[id]/rediger": [23,[2]],
		"/(auth)/produkt-cms": [24,[2]],
		"/(auth)/produkt-cms/ai/settings": [25,[2]],
		"/(auth)/produkt-cms/diagnostics": [26,[2]],
		"/(auth)/produkt-cms/editor": [27,[2]],
		"/(auth)/produkt-cms/group-trees": [28,[2]],
		"/(auth)/produkt-cms/import": [29,[2]],
		"/(auth)/produkt-cms/import/settings": [30,[2]],
		"/(auth)/produkt-cms/new": [31,[2]],
		"/(auth)/produkt-cms/settings": [32,[2]],
		"/(auth)/produkt-cms/settings/group-tree-attributes": [33,[2]],
		"/produkt/lokasjon": [80,[7]],
		"/produkt/lokasjon/innstillinger": [81,[7]],
		"/register": [82],
		"/register/success": [83],
		"/(auth)/seo-cms": [34,[2,3]],
		"/(auth)/seo-cms/debug": [35,[2,3]],
		"/(auth)/seo-cms/editor": [36,[2,3]],
		"/(auth)/seo-cms/innstillinger": [37,[2,3]],
		"/(auth)/settings": [38,[2]],
		"/(auth)/superadmin": [39,[2,4]],
		"/(auth)/superadmin/api-keys": [40,[2,4]],
		"/(auth)/superadmin/brukere": [41,[2,4]],
		"/(auth)/superadmin/firmaer": [42,[2,4]],
		"/(auth)/superadmin/firmaer/[id]": [43,[2,4]],
		"/(auth)/superadmin/firmaer/[id]/brukere": [44,[2,4]],
		"/(auth)/superadmin/home": [45,[2,4]],
		"/(auth)/superadmin/logs": [46,[2,4]],
		"/(auth)/superadmin/logs/viewer": [47,[2,4]],
		"/(auth)/superadmin/logs/[serviceId]": [48,[2,4]],
		"/(auth)/superadmin/maler": [49,[2,4]],
		"/(auth)/superadmin/services": [50,[2,4]],
		"/(auth)/superadmin/services/[serviceId]/support": [51,[2,4]],
		"/(auth)/superadmin/sql": [52,[2,4]],
		"/(auth)/superadmin/sql/[serviceId]": [53,[2,4]],
		"/(auth)/wms": [54,[2,5]],
		"/(auth)/wms/etiketter": [55,[2,5]],
		"/(auth)/wms/feedback-scenarios": [56,[2,5]],
		"/(auth)/wms/flytt": [57,[2,5]],
		"/(auth)/wms/lokasjoner": [58,[2,5]],
		"/(auth)/wms/lokasjoner/bygger": [59,[2,5]],
		"/(auth)/wms/mock": [60,[2,5]],
		"/(auth)/wms/mottak": [61,[2,5]],
		"/(auth)/wms/oppgaver": [62,[2,5]],
		"/(auth)/wms/plukklister": [65,[2,5]],
		"/(auth)/wms/plukklister/henteordre/[orderHeaderId]": [66,[2,5]],
		"/(auth)/wms/plukklister/plukk/[orderHeaderId]": [67,[2,5]],
		"/(auth)/wms/plukk": [63,[2,5]],
		"/(auth)/wms/plukk/[orderHeaderId]": [64,[2,5]],
		"/(auth)/wms/settings": [68,[2,5]],
		"/(auth)/wms/telling": [69,[2,5]],
		"/(auth)/wms/telling/planer": [70,[2,5]],
		"/(auth)/wms/varerobot": [71,[2,5]]
	};

export const hooks = {
	handleError: (({ error }) => { console.error(error) }),
	
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';

export const get_error_template = () => import('../shared/error-template.js').then(m => m.default);